import { useState } from 'react'
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/react'

function RistoSLiderFoto({ ristorante, flag3, ristorante2 }) {
    const [currentIndex, setCurrentIndex] = useState(0)

    const prevSlide = (name) => {
        if (name === 'ristorante') {//risto solo da google
            setCurrentIndex((prevIndex) => prevIndex === 0 ? ristorante.photos.length - 1 : prevIndex - 1)
        } else if (ristorante2) {//risto da google e da MYSQL
            setCurrentIndex((prevIndex) => prevIndex === 0 ? ristorante2.datiDaGoogle[0].photos.length - 1 : prevIndex - 1)
        } else if (ristorante2.img) {// risto solo da MYSQL
            setCurrentIndex((prevIndex) => prevIndex === 0 ? ristorante2.img.split(',').length - 1 : prevIndex - 1)
        }
    }
    const nextSlide = (name) => {
        if (name === 'ristorante') {//risto solo da google
            setCurrentIndex((prevIndex) => prevIndex === ristorante.photos.length - 1 ? 0 : prevIndex + 1)
        } else if (ristorante2.datiDaGoogle) {//risto da google e da MYSQL
            setCurrentIndex((prevIndex) => prevIndex === ristorante2.datiDaGoogle[0].photos.length - 1 ? 0 : prevIndex + 1)
        } else if (ristorante2.img) {// risto solo da MYSQL
            setCurrentIndex((prevIndex) => prevIndex === ristorante2.img.split(',').length - 1 ? 0 : prevIndex + 1)
        }
    }
    return (<>
        {/* ------------------- DIV PER VISUALIZZARE SLIDER-SHOW RISTO DA GOOGLE ----------------- */}
        {flag3 === 'terzoRistoGoogle' &&
            <div>
                {/* ------------------- DESKTOP ----------------- */}
                <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: 'whitesmoke', zIndex: '9999' }}>
                    <div className='addImg2' style={{
                        position: 'fixed', top: '22em', left: '50%', transform: 'translate(-50%, -50%)', border: '1px solid grey',
                        width: '600px', height: '450px', borderRadius: '8px', justifyContent: 'center', alignItems: 'center'
                    }}>
                        {ristorante && <p style={{ position: 'absolute', top: '-2em', fontSize: 'x-large' }}>{ristorante.displayName.text}</p>}
                        <img src={require('../image/icons8-chiudi-macos-32.png')} style={{
                            position: 'absolute', top: '-2.5em', left: '95%', cursor: 'pointer', width: '40px',
                        }} onClick={() => { window.history.back() }} alt='' />
                        <button className='left-arrow' onClick={() => { prevSlide('ristorante') }}>◀</button>
                        {ristorante &&
                            <img id="imgRistoDesktop"
                                src={`https://places.googleapis.com/v1/${ristorante.photos[currentIndex].name}/media?key=${process.env.REACT_APP_GOOGLE_MAPS}&maxWidthPx=550&maxHeightPx=478`}
                                style={{ width: '600px', height: '450px', borderRadius: '10px', objectFit: 'cover' }} alt='' />
                        }
                        <button className='right-arrow' onClick={() => { nextSlide('ristorante') }}>▶</button>
                        {ristorante &&
                            <p className='mt-1' style={{ position: 'absolute', top: '100%', textAlign: 'center', opacity: '.7' }}>
                                {ristorante.photos[currentIndex].authorAttributions[0].displayName}
                            </p>
                        }
                        <button className='btn btn-secondary mt-5' style={{ position: 'absolute', top: '100%', left: '0' }}
                            onClick={() => [window.history.back()]}>indietro</button>
                    </div>
                </div>

                {/* ------------------- MOBILE ----------------- */}
                <div className='iconChatMobile' style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: 'whitesmoke', zIndex: '9999' }}>
                    <div style={{
                        position: 'fixed', top: '19em', width: '98%', height: '340px', borderRadius: '8px',
                        left: '50%', transform: 'translate(-50%, -50%)', justifyContent: 'center', alignItems: 'center'
                    }}>
                        {ristorante && <p style={{ position: 'absolute', top: '-1.5em', fontSize: 'large', marginLeft: '2em' }}>{ristorante.displayName.text}</p>}
                        <img src={require('../image/icons8-chiudi-macos-32.png')} style={{ position: 'absolute', top: '-2.5em', left: '90%', cursor: 'pointer', width: '40px' }}
                            onClick={() => { window.history.back() }} alt='' />
                        <Swiper spaceBetween={10} slidesPerView={1} initialSlide={currentIndex} navigation pagination={{ clickable: true }} className='mt-4'>
                            {ristorante &&
                                ristorante.photos.map((photo, index) => (
                                    <SwiperSlide key={index + 'mobile'}>
                                        <img src={`https://places.googleapis.com/v1/${photo.name}/media?key=${process.env.REACT_APP_GOOGLE_MAPS}&maxWidthPx=300&maxHeightPx=300`}
                                            style={{ width: '100%', height: '300px', borderRadius: '10px', objectFit: 'cover' }} alt='' />
                                        <p style={{ marginTop: '1em', textAlign: 'center', opacity: '.7' }}>
                                            {photo.authorAttributions[0].displayName}
                                        </p>
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                        <button className='btn btn-secondary' onClick={() => { window.history.back() }}>Indietro</button>
                    </div>
                </div>
            </div>
        }
        {/* ------------------- DIV PER VISUALIZZARE SLIDER-SHOW RISTO DA MYSQL E DA GOOGLE ----------------- */}
        {/* ------------------- DESKTOP ----------------- */}
        {flag3 === 'terzoRistoMysql' &&
            <div>
                <div className='addImg2' style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: 'whitesmoke', zIndex: '9999' }}>
                    <div style={{
                        position: 'fixed', top: '22em', left: '50%', transform: 'translate(-50%, -50%)', border: '1px solid grey',
                        width: '600px', height: '450px', borderRadius: '8px', justifyContent: 'center', alignItems: 'center'
                    }}>
                        {ristorante2 &&
                            <p style={{ position: 'absolute', top: '-2em', fontSize: 'x-large' }}>{ristorante2.nome}</p>
                        }

                        <img src={require('../image/icons8-chiudi-macos-32.png')} style={{
                            position: 'absolute', top: '-2.5em', left: '95%', cursor: 'pointer', width: '40px',
                        }} onClick={() => [window.history.back()]} alt='' />
                        <button className='left-arrow' onClick={() => { prevSlide('ristorante2') }}>◀</button>

                        {ristorante2.datiDaGoogle ?
                            <img // foto su google API places
                                src={`https://places.googleapis.com/v1/${ristorante2.datiDaGoogle[0].photos[currentIndex].name}/media?key=${process.env.REACT_APP_GOOGLE_MAPS}&maxWidthPx=550&maxHeightPx=478`}
                                style={{ width: '100%', height: '446px', borderRadius: '10px', objectFit: 'cover' }} alt='' />
                            :
                            <img // foto su amazon S3 bucket
                                src={`https://leuro-bucket.s3.amazonaws.com/${ristorante2.img.split(',')[currentIndex]}`}
                                style={{ width: '100%', height: '446px', borderRadius: '10px' }} alt='' />
                        }
                        <button className='right-arrow' onClick={() => { nextSlide('ristorante2') }}>▶</button>
                        {ristorante2.datiDaGoogle ?// autore foto su google
                            <p className="mt-1" style={{ position: 'absolute', top: '100%', textAlign: 'center', opacity: '.7' }}>
                                {ristorante2.datiDaGoogle[0].photos[currentIndex].authorAttributions[0].displayName}
                            </p>
                            : // autore foto è il nome del risto perchè le foto sono state caricate in MYSQL dal ristorante
                            <p className="mt-1" style={{ position: 'absolute', top: '100%', textAlign: 'center', opacity: '.7' }}>
                                {ristorante2.nome}
                            </p>
                        }
                        <button className='btn btn-secondary mt-5' style={{ position: 'absolute', top: '100%', left: '0' }}
                            onClick={() => [window.history.back()]}>indietro</button>
                    </div>
                </div>


                {/* ------------------- MOBILE ----------------- */}
                <div className='iconChatMobile' style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: 'whitesmoke', zIndex: '9999' }}>
                    <div style={{
                        position: 'fixed', top: '19em', width: '98%', height: '340px', borderRadius: '8px',
                        left: '50%', transform: 'translate(-50%, -50%)', justifyContent: 'center', alignItems: 'center'
                    }}>
                        {ristorante2 &&
                            <p style={{ position: 'absolute', top: '-2em', fontSize: 'large', marginLeft: '1em' }}>{ristorante2.nome}</p>
                        }
                        <img src={require('../image/icons8-chiudi-macos-32.png')} style={{ position: 'absolute', top: '-2.5em', left: '90%', cursor: 'pointer', width: '40px' }}
                            onClick={() => [window.history.back()]} alt='' />
                        <Swiper spaceBetween={10} slidesPerView={1} navigation pagination={{ clickable: true }}>
                            {ristorante2.datiDaGoogle && // foto da google
                                ristorante2.datiDaGoogle[0].photos.map((photo, index) => (
                                    <SwiperSlide key={index + 'p8ec'}>
                                        <img src={`https://places.googleapis.com/v1/${photo.name}/media?key=${process.env.REACT_APP_GOOGLE_MAPS}&maxWidthPx=300&maxHeightPx=300`}
                                            style={{ width: '100%', height: '300px', borderRadius: '10px', objectFit: 'cover' }} alt='' />
                                        <p style={{ marginTop: '1em', textAlign: 'center', opacity: '.7' }}>
                                            {photo.authorAttributions[0].displayName}
                                        </p>
                                    </SwiperSlide>
                                ))
                            }
                            {ristorante2.img && // foto da MYSQL
                                ristorante2.img.split(',').map((photo, index) => (
                                    <SwiperSlide key={index + 'xylc'}>
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${photo}`}
                                            style={{ width: '100%', height: '300px', borderRadius: '10px', objectFit: 'cover' }} alt='' />
                                        <p style={{ marginTop: '1em', textAlign: 'center', opacity: '.7' }}>
                                            {ristorante2.nome}
                                        </p>
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                        <button className='btn btn-secondary mt-1' onClick={() => [window.history.back()]}>Indietro</button>
                    </div>
                </div>
            </div>
        }
    </>)
}
export default RistoSLiderFoto